import {normalizeBarcode,isValidGtin} from './domain.js';

export const NATIVE_BARCODE_FORMATS = Object.freeze([
  'ean_13','ean_8','upc_a','upc_e','code_128','code_39','itf',
]);

export function supportedRetailFormats(supported=[]){
  if(!Array.isArray(supported))return [];
  return NATIVE_BARCODE_FORMATS.filter(name=>supported.includes(name));
}

export function validateScannedCode(raw){
  const code=normalizeBarcode(raw);
  if(!code)return {code:'',valid:false,reason:'empty'};
  if(/^\d+$/.test(code)&&[8,12,13,14].includes(code.length)&&!isValidGtin(code)){
    return {code,valid:false,reason:'gtin'};
  }
  return {code,valid:true,reason:null};
}
